const TEN_SECONDS_IN_MILLISECONDS = 10 * 1000

export const APPLICATION_LIST_CONFIG = {
    revalidateAll: true,
    revalidateOnFocus: true,
    refreshInterval: TEN_SECONDS_IN_MILLISECONDS,
}

export const NO_REVALIDATE_CONFIG = {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
}

const REVALIDATE_ON_MOUNT_CONFIG = {
    revalidateOnMount: true,
}

export const DEVICE_REFERENCE_CONFIG = {
    ...REVALIDATE_ON_MOUNT_CONFIG,
}

export const NEW_VERSION_CONFIG = {
    ...REVALIDATE_ON_MOUNT_CONFIG,
}

export const NEW_AMENDMENT_CONFIG = {
    ...REVALIDATE_ON_MOUNT_CONFIG,
}

export const CONTINUE_DRAFT_CONFIG = {
    ...REVALIDATE_ON_MOUNT_CONFIG,
}

export const SEARCH_CONFIG = {
    revalidateAll: true,
    revalidateOnFocus: true,
    refreshInterval: TEN_SECONDS_IN_MILLISECONDS,
}
